export const ACUTE_GHVD_CLINICAL_SCORING = {
  masterTableName: "MC_ACUTE_GVHD_SCORE",
  tableName: "MC_ACUTE_GVHD_SCORE_DET",
  columnName: "AGS_ID",
  columnValue: 0,
  title: "acute-ghvd-clinical-scoring.title",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
    },
    {
      title: "SKIN",
      value: "SKIN_XNAME",
    },
    {
      title: "LIVER",
      value: "LIVER_XNAME",
    },
    {
      title: "UPPER_GIS",
      value: "UPPER_GIS_XNAME",
    },
    {
      title: "LOWER_GIS",
      value: "LOWER_GIS_XNAME",
    },
    {
      title: "SCORE",
      value: "SCORE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    {
      field: "SKIN",
      headerName: "acute-ghvd-clinical-scoring.skin",
      flex: 1,
    },
    {
      field: "LIVER",
      headerName: "acute-ghvd-clinical-scoring.liver",
      flex: 1,
    },
    {
      field: "UPPER_GIS",
      headerName: "acute-ghvd-clinical-scoring.upper-gis",
      flex: 1,
    },
    {
      field: "LOWER_GIS",
      headerName: "acute-ghvd-clinical-scoring.lower-gis",
      flex: 1,
    },
    {
      field: "SCORE",
      headerName: "acute-ghvd-clinical-scoring.score",
      flex: 1,
      computed: false,
      calculate: (row: any) => {
        if (!row) return 0;

        const skin = Number(row.SKIN_XVALUE) || 0;
        const liver = Number(row.LIVER_XVALUE) || 0;
        const upper_gis = Number(row.UPPER_GIS_XVALUE) || 0;
        const lower_gis = Number(row.LOWER_GIS_XVALUE) || 0;

        const totalScore = skin + liver + upper_gis + lower_gis;

        return totalScore;
      },
    },
  ],
  mcpConfig: {
    SKIN: { mcpId: 827, field: "SKIN", scoreField: "SKIN_XVALUE" },
    LIVER: { mcpId: 828, field: "LIVER", scoreField: "LIVER_XVALUE" },
    UPPER_GIS: {
      mcpId: 829,
      field: "UPPER_GIS",
      scoreField: "UPPER_GIS_XVALUE",
    },
    LOWER_GIS: {
      mcpId: 830,
      field: "LOWER_GIS",
      scoreField: "LOWER_GIS_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    AGS_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    SKIN: "",
    LIVER: "",
    UPPER_GIS: "",
    LOWER_GIS: "",
    SCORE: 0,
  },
  chartScoreField: "SCORE",
  chartTimeField: "PROCESS_TIME",
};
